export enum EAuthorization {
  NOITADA_USER = 'USER', // id: 66
  NOITADA_COMPANY = 'COMPANY', // id: 67
  NOITADA_ADMINISTRATION = 'ADMINISTRATION', // id: 68
}



export default EAuthorization;
